import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useState, useEffect } from "react";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Divider,
  Button,
  CircularProgress,
} from "@material-ui/core";
import AuditTable from "./AuditTable";
import { useLocation, Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: theme.spacing(1),
    fontFamily: "sans-serif",
  },
  backContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
  auditReportText: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    fontFamily: "sans-serif",
    fontSize: "1.5rem",
  },
  table: {
    minWidth: 650,
  },
  horizontalBox: {
    boxSizing: "border-box",
    width: "100%",
    borderBottom: "1px solid #ccc",
    backgroundColor: "#f2f8fb", // Light blue background color
    minHeight: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    gap: "1rem",
    padding: "8px 16px",
    borderRadius: "8px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  statusChip: {
    padding: "4px 16px",
    color: "#fff",
    borderRadius: "4px",
  },
  linkButton: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    textTransform: "none",
  },

  orangeButton: {
    backgroundColor: "#ec6535", // Orange background color
    color: "#fff",
    padding: "6px 16px",
    borderRadius: "20px",
    // fontWeight: "bold",
    textTransform: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    height: "fit-content",
    alignSelf: "center",
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },

  block: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "1rem",
  },
  errorText: {
    display: "block",
    width: "100%",
    fontSize: "14px",
    marginTop: "4px",
    padding: "1em",
    backgroundColor: "#f8d7da",
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
    height: "80dvh",
  },
  clickableTextSty: {
    // maxWidth: "250px",
    "&:hover": {
      textDecoration: "underline",
      color: "#2196F3",
      cursor: "pointer",
    },
  },
}));

export default function AuditReport() {
  const classes = useStyles();
  const [poData, setPoData] = useState(null);
  const [selectedLine, setSelectedLine] = useState("all");
  const [auditTrailData, setAuditTrailData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(false); //table error
  const [pageError, setPageError] = useState(false); //table error
  const location = useLocation();

  const SLDetailsData = location.state?.data;
  const schrockenSAID = SLDetailsData?.schrockenSAID || 27753;
  useEffect(() => {
    setPageLoading(true);
    setPageError(false);
    const fetchPOData = () => {
      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOAuditDetails`,
          { schrockenSAID }
        )
        .then((res) => {
          if (res.data.status) {
            setPoData(res.data.data);
            setPageLoading(false);
          }
        })
        .catch((err) => {
          //console.log("Error fetching data", err);
          setPageLoading(false);
          setPageError(true);
        });
    };

    fetchPOData();
    fetchAllPOLines();
    // setPoData(poHistoryData);
    // setSelectedLine(poHistoryData.poLineItemsList[0].schrockenSLID);
  }, [schrockenSAID]);

  const handleLineChange = (event) => {
    setSelectedLine(event.target.value);
  };
  const handleViewReport = () => {
    setTableLoading(true);
    setError(false);

    if (selectedLine === "none") {
      setAuditTrailData([]);
      setTableLoading(false);
      return;
    }

    if (selectedLine === "all") {
      //call api for all lines
      fetchAllPOLines();
      return;
    }

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineAuditDetails/`,
        { schrockenSLID: selectedLine }
      )
      .then((res) => {
        if (res.data.status) {
          setAuditTrailData(res.data.data.poLineAuditTrail);
          setTableLoading(false);
        } else {
          //console.log("Error fetching audit trail data:", res.data.message);
          setTableLoading(false);
        }
      })
      .catch((err) => {
        //console.log("Error fetching audit trail data", err);
        setTableLoading(false);
        setError(true);
      });
  };

  function fetchAllPOLines() {
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOAllLinesAuditDetails`,
        { schrockenSAID }
      )
      .then((res) => {
        if (res.data.status) {
          setAuditTrailData(res.data.data.poLineAuditTrail);
          setTableLoading(false);
        }
      })
      .catch((err) => {
        //console.log("Error fetching data", err);
        setTableLoading(false);
        setError(true);
      });
  }
  // Function to handle the "Back" button click event
  const handleBack = () => {
     window.history.back();
    };
  // Function to determine the background color based on poStatus
  const getStatusColor = (status) => {
    switch (status) {
      case "Created":
        return "#B4B4B4";

      case "Under confirmation":
        return "#E78A00";

      case "Shared with CMO":
        return "#2196F3";

      case "Confirmed":
        return "#707070";

      case "Approved":
        return "#329429";

      case "Rejected By CMO":
        return "#FF0000";

      case "Closed":
        return "#1E1E1E";
      default:
        return "#ccc"; // Default color if status is unknown
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate().toString().padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  if (pageError)
    return (
      <div>
        <div className={classes.errorContainer}>
          <div className={classes.errorText}>
            <Typography align="center">
              An error occurred while fetching the data. Please try again.
            </Typography>
          </div>
        </div>
      </div>
    );

  if (pageLoading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90dvh",
        }}
      >
        <CircularProgress color="primary" thickness={7} />
      </div>
    );

  return (
    <div>
      <nav className={classes.title}>
        <div className={classes.backContainer} onClick={handleBack}>
          <ArrowBackIcon aria-label="Go back" />
          <p style={{ marginLeft: "8px" }}>Back</p>
        </div>
        <div className={classes.auditReportText}>
          <h3>Audit Report</h3>
        </div>
      </nav>

      <Box className={classes.horizontalBox}>
        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500" }}>PO Number</span>

          {poData?.poNumber}
        </Typography>

        <Typography
          variant="body1"
          className={classes.block}
          style={{ display: "flex", justifyContent: "center", gap: "8px" }}
        >
          <span style={{ fontWeight: "500", verticalAlign: "middle" }}>
            Line
          </span>
          <Select
            variant="outlined"
            value={selectedLine}
            onChange={handleLineChange}
            style={{
              minWidth: "80px",
              maxWidth: "100px",
              maxHeight: "30px",
            }}
          >
            <MenuItem value="all">All</MenuItem>
            {poData?.poLineItemsList
              ?.sort((a, b) => {
                const itemA = `${a.scheduleLineItemNumber}-${a.productCode} / ${a.productName}`;
                const itemB = `${b.scheduleLineItemNumber}-${b.productCode} / ${b.productName}`;
                return itemA.localeCompare(itemB);
              })
              .map((item) => (
                <MenuItem key={item.schrockenSLID} value={item.schrockenSLID}>
                  {`${item.scheduleLineItemNumber}-${item.productCode} / ${item.productName}`}
                </MenuItem>
              ))}
            {/* {poData?.poLineItemsList?.map((item) => (
              <MenuItem key={item.schrockenSLID} value={item.schrockenSLID}>
              {`${item.scheduleLineItemNumber}-${item.productCode} / ${item.productName}`}
              </MenuItem>
              ))} */}
            <MenuItem value="none">None</MenuItem>
          </Select>
        </Typography>
        <Button className={classes.orangeButton} onClick={handleViewReport}>
          View Report
        </Button>

        <Divider orientation="vertical" flexItem />

        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500" }}>CMO Name</span>
          {poData?.vendorName}
        </Typography>
        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500" }}>Date of Creation</span>
          {poData?.creationDate && formatDate(poData.creationDate)}
        </Typography>
        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500" }}>Created By</span>
          {poData?.createdBy}
        </Typography>
        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500", textAlign:'center' }}>PO Status</span>

          <span
            className={classes.statusChip}
            style={{
              backgroundColor: poData
                ? getStatusColor(poData.poStatus)
                : "#ccc",
            }}
          >
            {poData?.poStatus}
          </span>
        </Typography>
        <Typography variant="body1" className={classes.block}>
          <span style={{ fontWeight: "500" }}>PO PDF</span>

          <a className={classes.clickableTextSty}>
                      Click here to download
                    </a>
          {/* <Link
            // to="#"
            style={{
              textDecoration: "underline",
              color: "#4AA3DF",
              cursor: "pointer",
            }}
          >
            Click here to download
          </Link> */}
        </Typography>
      </Box>

      <AuditTable
        poAuditTrail={
          auditTrailData?.length ? auditTrailData : poData?.poAuditTrail
        }
        error={error}
        loading={tableLoading}
      />
    </div>
  );
}
